import React from 'react';
import CrudTable from '../../components/admin/CrudTable';

export default function ManageServices() {
  return (
    <CrudTable
      entity="services"
      title="Xidmətlər"
      defaults={{ title: '', content: '', order: 0 }}
      fields={[
        { key: 'title', label: 'Başlıq', type: 'text' },
        { key: 'content', label: 'Məzmun (formatlaşdırıla bilər)', type: 'richText' },
        { key: 'order', label: 'Sıra', type: 'number' },
      ]}
      listColumns={[
        { key: 'title', label: 'Başlıq' },
        { key: 'order', label: 'Sıra' },
      ]}
    />
  );
}
